import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppHelper } from '@app/core/app.helper';
import { AuthGuard } from './auth.guard';
import { EAccessAlias } from './enums';

/** Роутинг системы */
const routes: Routes = [
    {
        path: 'desktop',
        loadChildren: () => import('../../modules/desktop/modules/desktop.module').then((mod) => mod.DesktopModule),
        data: {
            permissions: EAccessAlias.DesktopPermission,
            is_public: false,
        },
    },
    {
        path: 'access',
        canActivate: [AuthGuard],
        loadChildren: () => import('../../modules/level-access/modules/access.module').then((mod) => mod.AccessModule),
        data: {
            permissions: EAccessAlias.modulePermission,
            is_public: false,
        },
    },
    {
        path: 'numerators',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('../../modules/numerator/modules/numerator.module').then((mod) => mod.NumeratorModule),
        data: {
            permissions: EAccessAlias.NumeratorPermission,
            is_public: false,
        },
    },
    {
        path: 'rubricators',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('../../modules/rubricator/modules/rubricator.module').then((mod) => mod.RubricatorModule),
        data: {
            permissions: EAccessAlias.rubricatorsPermission,
            is_public: false,
        },
    },
    {
        path: 'roles',
        canActivate: [AuthGuard],
        loadChildren: () => import('../../modules/roles/modules/roles.module').then((mod) => mod.RolesModule),
        data: {
            permissions: EAccessAlias.modulePermission,
            is_public: false,
        },
    },
    {
        path: 'settings',
        canActivate: [AuthGuard],
        loadChildren: () => import('../../modules/settings/modules/settings.module').then((mod) => mod.SettingsModule),
        data: {
            permissions: EAccessAlias.modulePermission,
            is_public: false,
        },
    },
    {
        path: 'subject',
        canActivate: [AuthGuard],
        loadChildren: () => import('./../modules/subjects/subject.module').then((mod) => mod.SubjectModule),
        data: {
            permissions: 'subject',
            is_public: false,
        },
    },
    {
        path: 'sapu',
        canActivate: [AuthGuard],
        loadChildren: () => import('./../modules/sapu/sapu.module').then((mod) => mod.SapuModule),
        data: {
            permissions: 'factor',
            is_public: false,
        },
    },

    {
        path: 'approval-module',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./../modules/approval-module/approval-module.module').then((mod) => mod.ApprovalModuleModule),
        data: {
            permissions: 'approval_module',
            is_public: false,
        },
    },
    {
        path: 'external_layers',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./../modules/external-layers/external-layers.module').then((mod) => mod.ExternalLayersModule),
        data: {
            permissions: 'external_layers',
            is_public: false,
        },
    },
    {
        path: 'messages',
        loadChildren: () => import('@modules/messages/modules/messages.module').then((mod) => mod.MessagesModule),
        data: {
            permissions: EAccessAlias.modulePermission,
            is_public: false,
        },
    },
    {
        path: 'factor_create/:id',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./../modules/factor-create/factor-create.module').then((mod) => mod.FactorCreateModule),
        data: {
            permissions: 'factor_input',
            is_public: false,
        },
    },
    {
        path: 'factor/input/:id',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./../modules/factor-input/modules/factor-input.module').then((mod) => mod.FactorInputModule),
        data: {
            permissions: 'factor_input',
            is_public: false,
        },
    },
    {
        path: 'factor/input/row/:factor_data_id/:relation_id/:opener_id',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('../modules/factor-row/modules/factor-row.module').then((mod) => mod.FactorRowModule),
        data: {
            permissions: 'factor_input',
            is_public: false,
        },
    },
    {
        path: 'factor/input/row/:factor_data_id',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('../modules/factor-row/modules/factor-row.module').then((mod) => mod.FactorRowModule),
        data: {
            permissions: 'factor_input',
            is_public: false,
        },
    },
    {
        path: 'factor/input/form/:factor_id',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('../modules/factor-row/modules/factor-row.module').then((mod) => mod.FactorRowModule),
        data: {
            permissions: 'factor_input',
            is_public: false,
        },
    },
    {
        path: 'factor/moderation/form/:factor_id',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('../modules/factor-row/modules/factor-row.module').then((mod) => mod.FactorRowModule),
        data: {
            permissions: 'check_data',
            is_public: false,
        },
    },
    {
        path: 'factor/moderation/row/:factor_data_id',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('../modules/factor-row/modules/factor-row.module').then((mod) => mod.FactorRowModule),
        data: {
            permissions: 'check_data',
            is_public: false,
        },
    },
    {
        path: 'regulations',
        canActivate: [AuthGuard],
        loadChildren: () => import('./../modules/regulations/regulations.module').then((mod) => mod.RegulationsModule),
        data: {
            permissions: 'regulations',
            is_public: false,
        },
    },
    {
        path: 'regulations/regulation/:id',
        canActivate: [AuthGuard],
        loadChildren: () => import('./../modules/regulation/regulation.module').then((mod) => mod.RegulationModule),
        data: {
            permissions: 'regulations',
            is_public: false,
        },
    },
    {
        path: 'technical-process-items',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./../modules/technical-process-items/technical-process-items.module').then(
                (mod) => mod.TechnicalProcessItemsModule,
            ),
        data: {
            permissions: 'technical_process',
            is_public: false,
        },
    },
    {
        path: 'logevent/index',
        canActivate: [AuthGuard],
        loadChildren: () => import('@modules/logevent/modules/logevent.module').then((mod) => mod.LogeventModule),
        data: {
            permissions: 'logevent',
            is_public: false,
        },
    },
    {
        path: 'log-registry/index',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('@modules/log-registry/modules/log-registry.module').then((mod) => mod.LogRegistryModule),
        data: {
            permissions: 'log_registry',
            is_public: false,
        },
    },
    {
        path: 'unit/index',
        canActivate: [AuthGuard],
        loadChildren: () => import('./../modules/unit/unit.module').then((mod) => mod.UnitModule),
        data: {
            permissions: 'unit',
            is_public: false,
        },
    },
    {
        path: 'technical-process-items/technical-process-item/:id',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./../modules/technical-process-item/technical-process-item.module').then(
                (mod) => mod.TechnicalProcessItemModule,
            ),
        data: {
            permissions: 'technical_process',
            is_public: false,
        },
    },
    {
        path: 'setting-up-orders',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./../modules/setting-up-regulations/setting-up-regulations.module').then(
                (mod) => mod.SettingUpRegulationsModule,
            ),
        data: {
            permissions: 'setting_up_orders',
            is_public: false,
        },
    },
    {
        path: 'technical-process-items/work/:technical_process_id/:id',
        canActivate: [AuthGuard],
        loadChildren: () => import('./../modules/work/work.module').then((mod) => mod.WorkModule),
        data: {
            permissions: 'technical_process',
            is_public: false,
        },
    },
    {
        path: 'technical-process-items/check/:technical_process_id/:id',
        canActivate: [AuthGuard],
        loadChildren: () => import('./../modules/check/check.module').then((mod) => mod.CheckModule),
        data: {
            permissions: 'technical_process',
            is_public: false,
        },
    },
    {
        path: 'user/userlist',
        canActivate: [AuthGuard],
        loadChildren: () => import('../../modules/users/modules/user-list.module').then((mod) => mod.UserListModule),
        data: {
            permissions: 'users',
            is_public: false,
        },
    },
    {
        path: 'coordinate_setting_system/index',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./../modules/coordinate-setting-system/coordinate-setting-system.module').then(
                (mod) => mod.CoordinateSettingSystemModule,
            ),
        data: {
            permissions: 'coordinate_setting_system',
            is_public: false,
        },
    },
    {
        path: 'user/userlist/:id',
        canActivate: [AuthGuard],
        loadChildren: () => import('../../modules/users/modules/user-list.module').then((mod) => mod.UserListModule),
        data: {
            permissions: 'users',
            is_public: false,
            link: 'user/userlist',
        },
    },
    {
        path: 'login',
        loadChildren: () => import('../../modules/login/modules/login.module').then((mod) => mod.LoginModule),
        data: {
            title: 'system_login_to_the_system',
            is_public: true,
            link: '/login',
        },
    },
    {
        path: 'login/recovery/:id/:access_hash',
        loadChildren: () =>
            import('./../modules/password-recovery-page/modules/password-recovery-page.module').then(
                (mod) => mod.PasswordRecoveryPageModule,
            ),
        data: {
            title: 'settings_pass_recovery',
            is_public: true,
            link: '/login/recovery',
        },
    },
    {
        path: 'pricing-factors',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./../modules/pricing-factors/pricing-factors.module').then((mod) => mod.PricingFactorsModule),
        data: {
            permissions: 'pricing_factors',
            is_public: false,
        },
    },
    {
        path: 'pricing-factors/pricing-factor/:id',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./../modules/pricing-factor/pricing-factor.module').then((mod) => mod.PricingFactorModule),
        data: {
            permissions: 'pricing_factors',
            is_public: false,
        },
    },
    {
        path: 'report/build',
        loadChildren: () =>
            import('./../modules/public-report/public-report.module').then((mod) => mod.PublicReportModule),
        data: {
            title: 'Build reports',
            is_public: !AppHelper.isAuth(),
            header_button: { name: 'system_login_to_the_system', link: '/login' },
        },
    },
    {
        path: 'report/build/:id',
        loadChildren: () =>
            import('./../modules/public-report/public-report.module').then((mod) => mod.PublicReportModule),
        data: {
            title: 'Build reports',
            is_public: true,
        },
    },
    {
        path: 'sync-guide',
        canActivate: [AuthGuard],
        loadChildren: () => import('./../modules/sync-guide/sync-guide.module').then((mod) => mod.SyncGuideModule),
        data: {
            title: 'Build reports',
            is_public: false,
            permissions: 'sync_guide',
        },
    },
    {
        path: 'sync-guide/sync-guide-item/:alias',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./../modules/sync-guide-item/sync-guide-item.module').then((mod) => mod.SyncGuideItemModule),
        data: {
            title: 'Build reports',
            is_public: false,
            permissions: 'sync_guide',
        },
    },
    {
        path: 'sync-guide/sync-guide-item-request/:alias',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./../modules/sync-guide-item-request/sync-guide-item-request.module').then(
                (mod) => mod.SyncGuideItemRequestModule,
            ),
        data: {
            title: 'Build reports',
            is_public: false,
            permissions: 'sync_guide',
        },
    },
    {
        path: 'palettes',
        canActivate: [AuthGuard],
        loadChildren: () => import('../../modules/palettes/modules/palettes.module').then((mod) => mod.PalettesModule),
        data: {
            is_public: false,
            permissions: 'palette',
        },
    },
    {
        path: 'notifications',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./../modules/notifications/notifications.module').then((mod) => mod.NotificationsModule),
        data: {
            is_public: false,
            permissions: 'notification',
        },
    },
    {
        path: 'notification_all',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./../modules/notifications-all/notifications-all.module').then((mod) => mod.NotificationsAllModule),
        data: {
            is_public: false,
            permissions: 'notification_all',
        },
    },
    {
        path: 'pages/:id/:menuId',
        canActivate: [AuthGuard],
        loadChildren: () => import('./../modules/fui-pages/fui-pages.module').then((mod) => mod.FuiPagesModule),
        data: {
            is_public: false,
            permissions: 'fui_pages',
        },
    },
    {
        path: 'esia_rostov/consume',
        loadChildren: () => import('../../modules/login/modules/login.module').then((mod) => mod.LoginModule),
        data: {
            is_public: true,
            title: 'esia_rostov',
        },
    },
    {
        path: 'personal-folder',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./../modules/user-personal-folder/user-personal-folder.module').then(
                (mod) => mod.UserPersonalFolderModule,
            ),
        data: {
            permissions: 'personal_folder',
            is_public: false,
        },
    },
    {
        path: 'settings/index',
        canActivate: [AuthGuard],
        loadChildren: () => import('../../modules/settings/modules/settings.module').then((mod) => mod.SettingsModule),
        data: {
            is_public: false,
            permissions: 'settings',
        },
    },
    {
        path: 'bind-with-map',
        loadChildren: () =>
            import('./../modules/bind-with-map/bind-with-map.module').then((mod) => mod.BindWithMapModule),
        data: {
            is_public: false,
            permissions: 'factor',
        },
    },
    {
        path: 'rso-guide',
        canActivate: [AuthGuard],
        loadChildren: () => import('./../modules/rso-guide/rso-guide.module').then((mod) => mod.RsoGuideModule),
        data: {
            is_public: false,
            permissions: 'factor',
        },
    },
    {
        path: 'handbook-calculations',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./../modules/handbook-calculations/handbook-calculations.module').then(
                (mod) => mod.HandbookCalculationsModule,
            ),
        data: {
            is_public: false,
            permissions: 'factor',
        },
    },
    {
        path: 'analytics',
        loadChildren: () => import('./../modules/analytics/analytics.module').then((mod) => mod.AnalyticsModule),
        data: {
            is_public: false,
        },
    },
    {
        path: 'doc/:alias',
        loadChildren: () => import('./../modules/doc/doc.module').then((mod) => mod.DocModule),
        data: {
            title: '',
            is_public: true,
        },
    },
    {
        path: '',
        redirectTo: 'factor/input',
        pathMatch: 'full',
    },
    {
        path: 'reports',
        canActivate: [AuthGuard],
        loadChildren: () => import('@modules/reports/modules/reports.module').then((mod) => mod.ReportsModule),
        data: {
            permissions: EAccessAlias.modulePermission,
            is_public: false,
        },
    },
    {
        path: 'factor',
        canActivate: [AuthGuard],
        loadChildren: () => import('@modules/factor/modules/factor.module').then((mod) => mod.FactorModule),
        data: {
            permissions: EAccessAlias.modulePermission,
            is_public: false,
        },
    },
    {
        path: 'page-not-found/:num',
        loadChildren: () =>
            import('./../modules/page-not-found/page-not-found.module').then((mod) => mod.PageNotFoundModule),
        data: {
            title: 'system_title_page_not_found',
            is_public: true,
            header_button: { name: 'system_login_to_the_system', link: '/login' },
        },
    },
    {
        path: '**',
        loadChildren: () =>
            import('./../modules/page-not-found/page-not-found.module').then((mod) => mod.PageNotFoundModule),
        data: {
            title: 'system_title_page_not_found',
            is_public: true,
            header_button: { name: 'system_login_to_the_system', link: '/login' },
        },
    },
];

/**
 * Модуль роутинга системы
 */
@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
    declarations: [],
})
export class AppRoutingModule {}
